import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import * as $ from 'jquery';
import 'datatables.net';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})

// This component is for getting list of users
export class UsersComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  public rows = [];
  public columns = [];
  page: number;
  deleteId;
  display = 'none';
  zIndex;
  showDialog;
  dataTablesPara;
  subscribeLabel = 'Subscribers';
  public searchKey = '';
  public subscriberSearchKey = '';
  public checkedSubscribed = false;
  public totalRecords = 0;
  totalRecords$ = new BehaviorSubject<number>(0);

  // New tab state
  activeTab: 'all' | 'duplicates' | 'ghosts' = 'all';
  duplicateAccounts: any[] = [];
  ghostAccounts: any[] = [];
  expandedGroups: { [key: string]: boolean } = {};

  constructor(private authenticationService: AuthenticationService,
              private router: Router,
              private toastr: ToastrService) { }

  // This function is called when page loads
  ngOnInit(): void {
    this.loadInit();
  }

  setTab(tab: 'all' | 'duplicates' | 'ghosts') {
    this.activeTab = tab;
    if (tab === 'duplicates' && this.duplicateAccounts.length === 0) {
      this.fetchDuplicateAccounts();
    } else if (tab === 'ghosts' && this.ghostAccounts.length === 0) {
      this.fetchGhostAccounts();
    }
  }

  fetchDuplicateAccounts() {
    this.authenticationService.getDuplicateAccounts().subscribe((res: any) => {
      if (res.success) {
        this.duplicateAccounts = res.data || [];
      } else {
        this.toastr.error('Failed to load duplicate accounts');
      }
    }, err => {
      console.error(err);
      this.toastr.error('Error fetching duplicate accounts');
    });
  }

  fetchGhostAccounts() {
    this.authenticationService.getEmptyAccounts().subscribe((res: any) => {
      if (res.success) {
        this.ghostAccounts = res.data || [];
      } else {
        this.toastr.error('Failed to load ghost accounts');
      }
    }, err => {
      console.error(err);
      this.toastr.error('Error fetching ghost accounts');
    });
  }

  toggleGroup(groupId: string) {
    this.expandedGroups[groupId] = !this.expandedGroups[groupId];
  }

    loadInit() {
      this.dtOptions = {
        pagingType: 'full_numbers',
        serverSide: true,
        processing: false,
        searching: true,
        ordering: true,
        responsive: true,
        columnDefs: [{
          targets: [7], /* column index */
          orderable: false, /* true or false */
          width: '300px',
        },
        {
          targets: [6], // the sixth columns
          orderable: false // disable sorting for these columns
        }],
        ajax: (dataTablesParameters: any, callback) => {
          const subs = localStorage.getItem('subscriberSearchKey') === 'true' ? localStorage.getItem('subscriberSearchKey') : '';
          const localSearchKeyData = localStorage.getItem('searchKey');
          this.searchKey = dataTablesParameters.search.value;
          dataTablesParameters.search.value = localSearchKeyData ? localSearchKeyData : (this.searchKey ? this.searchKey : '');
          this.dataTablesPara = dataTablesParameters;
          this.checkedSubscribed = Boolean(subs);
          this.authenticationService.getUsersList(dataTablesParameters, Boolean(subs)).subscribe(
            (resp: any) => {
              if (resp.statusCode === 200) {
                this.rows = resp.user[0].data;
                localStorage.removeItem('searchKey');
                localStorage.removeItem('subscriberSearchKey');
                this.totalRecords = resp.user[0].metadata[0]?.total ? resp.user[0].metadata[0]?.total : 0;
                this.totalRecords$.next(this.totalRecords);
                this.totalRecords$.subscribe((totalRecords) => {
                  callback({
                    recordsTotal: totalRecords,
                    recordsFiltered: totalRecords,
                    data: []
                  });
                });
              }
            }, err => {
              console.log('Error', err);
            }
          );
        }
      };
    }

  // Function to filter users who purchased a subscription plan
  checked(event: any) {
    let subs = false;
    this.subscribeLabel = 'Subscribers';
    if (event && event.target && event.target.checked) {
      subs = true;
      this.subscribeLabel = 'Subscribers';
    }
    this.subscriberSearchKey = String(subs);
    localStorage.setItem('subscriberSearchKey', this.subscriberSearchKey);
    this.authenticationService.getUsersList(this.dataTablesPara, subs).subscribe(
      (resp: any) => {
        if (resp) {
          this.rows = resp.user[0].data;
          this.totalRecords = resp.user[0].metadata[0]?.total ? resp.user[0].metadata[0]?.total : 0;
          this.totalRecords$.next(this.totalRecords);
        }
      });
  }

  // Function to delete user
  deleteUser(id) {
    const userId = id;
    this.display = 'none';
    this.authenticationService.deleteUser(userId).subscribe((res) => {
      const index = this.rows.findIndex(x => x._id === userId);
      this.rows.splice(index, 1);
      const subs = localStorage.getItem('subscriberSearchKey') === 'true' ? localStorage.getItem('subscriberSearchKey') : 'false';
      this.authenticationService.getUsersList(this.dataTablesPara, subs).subscribe(
        (resp: any) => {
          if (resp) {
            this.rows = resp.user[0].data;
            this.totalRecords = resp.user[0].metadata[0]?.total ? resp.user[0].metadata[0]?.total : 0;
            this.totalRecords$.next(this.totalRecords);
          }
        });
    });
  }

  // Function to get user details and also redirect to user page
  getUserId(id) {
    this.router.navigateByUrl('/user/' + id);
  }

  // Function to change active status of an user
  changeStatus(id: any, event: any) {
    const status = {
      status: Number(event.target.checked)
    };
    this.authenticationService.changeStatus(id, status).subscribe((res: any) => {
      if (res.body.status === 200) {
        this.toastr.success(res.body.message);
      }
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  deleteModelDiallog(deleteId) {
    this.deleteId = deleteId;
    this.display = 'block'; // Set block css
    this.zIndex = '0';
    this.showDialog = 1;
  }


  closeModalDialog() {
    this.display = 'none'; // set none css after close dialog
  }

  getUsersDetailPage(userId) {
    localStorage.setItem('searchKey', this.searchKey);
    localStorage.setItem('subscriberSearchKey', this.subscriberSearchKey);
    this.router.navigateByUrl('/user-profile/' + userId);
  }

  getUsersEditPage(userId) {
    localStorage.setItem('searchKey', this.searchKey);
    localStorage.setItem('subscriberSearchKey', this.subscriberSearchKey);
    this.router.navigateByUrl('/user/' + userId);
  }

}
